import { useEffect } from "react";
import { Auth } from "@aws-amplify/auth";

import { LOGOUT_EVENT } from "fond/constants";

import { stopImpersonating } from "../impersonate";

/**
 * Component that listens for logout events from other tabs and signs out the current tab.
 * Uses localStorage storage events for cross-tab communication.
 */
export const CrossTabLogoutListener: React.FC = () => {
  useEffect(() => {
    const handleLogout = (e: StorageEvent) => {
      // Check if the logout event was triggered
      if (e.key === LOGOUT_EVENT && e.newValue) {
        // Perform logout in this tab
        stopImpersonating();
        Auth.signOut();
        sessionStorage.clear();

        // Force full page reload to signin page
        window.location.href = "/signin";
      }
    };

    window.addEventListener("storage", handleLogout);

    return () => window.removeEventListener("storage", handleLogout);
  }, []);

  return null;
};
